import { useNavigate } from "react-router-dom";
import { LogOut, User, Mail, ShieldCheck } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import BudgetEditor from "../components/BudgetEditor";
import CategoryManager from "../components/CategoryManager";
import BackupCard from "../components/BackupCard";
import DangerZone from "../components/DangerZone";
import AccountManager from "../components/AccountManager";
import InvitesCard from "../components/InvitesCard";

export default function SettingsPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isOwner = user?.role === "owner";

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="space-y-6 fade-in-up max-w-2xl" data-testid="settings-page">
      <h1 className="font-heading text-2xl md:text-3xl font-bold tracking-tight">Ayarlar</h1>

      <div className="bg-card border border-border rounded-2xl p-6 space-y-5">
        <div className="flex items-center gap-4">
          {user?.picture ? (
            <img src={user.picture} alt={user.name} className="w-14 h-14 rounded-full border border-border" />
          ) : (
            <div className="w-14 h-14 rounded-full bg-primary/15 flex items-center justify-center">
              <User className="w-6 h-6 text-primary" />
            </div>
          )}
          <div>
            <p data-testid="settings-user-name" className="font-heading font-semibold text-lg">{user?.name}</p>
            <p className="text-sm text-muted-foreground">Usta Hesap kullanıcısı</p>
          </div>
        </div>

        <div className="space-y-3 pt-2 border-t border-border">
          <div className="flex items-center gap-3 pt-3">
            <Mail className="w-4 h-4 text-muted-foreground" />
            <span data-testid="settings-user-email" className="text-sm">{user?.email}</span>
          </div>
          <div className="flex items-center gap-3">
            <ShieldCheck className="w-4 h-4 text-muted-foreground" />
            <span className="text-sm">
              Giriş yöntemi: {user?.auth_provider === "google" ? "Google" : "E-posta / Şifre"}
            </span>
          </div>
        </div>
      </div>

      <InvitesCard />

      <AccountManager />

      <CategoryManager />

      {isOwner && <BudgetEditor />}

      <BackupCard canImport={isOwner} />

      {isOwner && <DangerZone />}

      <Button data-testid="logout-button" variant="outline" onClick={handleLogout}
        className="rounded-full border-destructive/50 text-destructive hover:bg-destructive/10 hover:text-destructive">
        <LogOut className="w-4 h-4 mr-2" /> Çıkış Yap
      </Button>
    </div>
  );
}
